module.exports = __webpack_public_path__ + "static/media/icono-dressing.f19cf52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-dressing.png
// module id = 306
// module chunks = 0